<div
  #helpDialog
  aria-describedby="modal-body"
  aria-labelledby="modalTitle"
  class="help-modal"
  role="dialog"
  tabindex="0"
>
  <div class="container content mt-lg-0 border-top-0 p-0">
    <button
      (click)="close()"
      class="help-modal-close icon-moreoptionsclose float-right circle-outline"
      type="button"
    >
      <img
        alt="close"
        class="ng-tns-c0-0"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
    </button>
    <h4
      [innerHTML]="tooltipContent?.tooltiptitle"
      class="title"
      id="modalTitle"
    ></h4>
    <div class="modal-body pl-0 pr-0" id="modal-body">
      <p [innerHTML]="tooltipContent?.tooltipDescription"></p>
    </div>
  </div>
</div>
